export const groupSessionsByVenueMovie = (acc, cur) => {
    const sessionDate = cur.session_date;

    if (
        typeof sessionDate !== "string" ||
        !sessionDate.includes("T") ||
        !cur.venue_id ||
        !cur.movie_id
    ) {
        return acc;
    }

    const dateOnly = sessionDate.split("T")[0];
    const dateObj = new Date(sessionDate);
    if (isNaN(dateObj.getTime())) {
        return acc;
    }

    const key = `${cur.venue_id}-${cur.movie_id}`;
    const index = acc.findIndex((i) => i.key === key);

    const session = {
        ...cur,
        session_date: sessionDate,
        date: dateOnly,
        d: dateObj,
    };

    if (index !== -1) {
        acc[index].sessions.push(session);
        return acc;
    }

    acc.push({
        key,
        cinema_group_id: parseInt(cur.cinema_group_id),
        movie_id: cur.movie_id,
        movie_title: cur.movie_title,
        movie_image: cur.movie_image,
        movie_run_time: cur.movie_run_time,
        movie_release_year: cur.movie_release_year,
        movie_rating: cur.movie_rating,
        movie_genre: cur.movie_genre,
        movie_blurb: cur.movie_blurb,
        trailer_url: cur.trailer_url,
        venue_id: cur.venue_id,
        venue_name: cur.venue_name,
        venue_address: cur.venue_address,
        venue_suburb: cur.venue_suburb,
        venue_postcode: cur.venue_postcode,
        venue_state: cur.venue_state,
        venue_distance: cur.venue_distance ?? 9999,
        venue_image: cur.venue_image,
        sessions: [session],
    });

    return acc;
};


export const groupSessionsByMovie = (acc, cur) => {
    const sessionDate = cur.session_date;

    if (
        typeof sessionDate !== "string" ||
        !sessionDate.includes("T") ||
        !cur.movie_id
    ) {
        return acc;
    }

    const dateOnly = sessionDate.split("T")[0];
    const dateObj = new Date(sessionDate);
    if (isNaN(dateObj.getTime())) {
        return acc;
    }

    const key = cur.movie_id;
    const index = acc.findIndex((i) => i.key === key);

    const session = {
        ...cur,
        session_date: sessionDate,
        date: dateOnly,
        d: dateObj,
    };

    if (index !== -1) {
        acc[index].sessions.push(session);
        return acc;
    }

    acc.push({
        key,
        movie_id: cur.movie_id,
        movie_image: cur.movie_image,
        movie_title: cur.movie_title,
        movie_run_time: cur.movie_run_time,
        movie_rating: cur.movie_rating,
        movie_genre: cur.movie_genre,
        movie_blurb: cur.movie_blurb,
        trailer_url: cur.trailer_url,
        sessions: [session],
    });

    return acc;
};


// For experiences page only

export const groupSessionsByVenueWithMovies = (acc, cur) => {
    const sessionDate = cur.session_date;

    if (
        typeof sessionDate !== "string" ||
        !sessionDate.includes("T") ||
        !cur.venue_id ||
        !cur.movie_id
    ) {
        return acc;
    }

    const dateOnly = sessionDate.split("T")[0];
    const dateObj = new Date(sessionDate);
    if (isNaN(dateObj.getTime())) {
        return acc;
    }

    const session = {
        ...cur,
        session_date: sessionDate,
        date: dateOnly,
        d: dateObj,
    };

    let venue = acc.find((v) => v.venue_id === cur.venue_id);

    if (!venue) {
        venue = {
            venue_id: cur.venue_id,
            venue_name: cur.venue_name,
            venue_address: cur.venue_address,
            venue_suburb: cur.venue_suburb,
            venue_postcode: cur.venue_postcode,
            venue_state: cur.venue_state,
            venue_distance: cur.venue_distance ?? 9999,
            venue_image: cur.venue_image,
            cinema_group_id: parseInt(cur.cinema_group_id),
            sessionsByMovie: {},
        };
        acc.push(venue);
    }

    const movieId = cur.movie_id;
    if (!venue.sessionsByMovie[movieId]) {
        venue.sessionsByMovie[movieId] = {
            movie_id: cur.movie_id,
            movie_title: cur.movie_title,
            movie_image: cur.movie_image,
            movie_run_time: cur.movie_run_time,
            movie_release_year: cur.movie_release_year,
            movie_rating: cur.movie_rating,
            movie_genre: cur.movie_genre,
            movie_blurb: cur.movie_blurb,
            trailer_url: cur.trailer_url,
            sessions: [],
        };
    }

    venue.sessionsByMovie[movieId].sessions.push(session);

    return acc;
};
